import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Switch, Typography } from '@mui/material'
import { useState } from 'react'
import useDebounce from 'utils/customHook/useDebounce'
import HelpParameter from '../HelpParameter'

const ParameterWithSwitch = ({
    parameters = [],
    setParameters = () => {},
    getGlobalParameter = () => {},
    moduleParameters = [],
    setModuleParameters = () => {},
    getGlobalModuleParameter = () => {},
    isGlobal = false,

    parameter = '',
    title = '',
    helpImage,
    invertValue = false,
    description,
}) => {
    const foundParameter = parameters.find(p => p.parameter === parameter)?.value
    const foundModuleParameter = moduleParameters.find(p => p.parameter === parameter)?.value

    const [stateParameter, setStateParameter] = useState(foundParameter === 'true')
    const [moduleStateParameter, setModuleStateParameter] = useState(foundModuleParameter === 'true')

    useDebounce(() => {
        setParameters(prev => [
            ...prev.filter(p => p.parameter !== parameter),
            getGlobalParameter(parameter, `${stateParameter}`),
        ])
    }, 200, [stateParameter])

    useDebounce(() => {
        setModuleParameters(prev => [
            ...prev.filter(p => p.parameter !== parameter),
            getGlobalModuleParameter(parameter, `${moduleStateParameter}`),
        ])
    }, 200, [moduleStateParameter])

    return (
        <Grid container justifyContent='space-between' alignItems='center' columnSpacing={1}>
            <Grid size={0.5}>
                <HelpParameter image={helpImage} />
            </Grid>
            <Grid container direction='column' size='grow'>
                <Typography variant='normalFormTitle'>{title}</Typography>
                {description}
            </Grid>
            {isGlobal && <Grid offset={3.25} />}
            <Grid container size={3.25}>
                <Switch
                    checked={invertValue ? !stateParameter : stateParameter}
                    onClick={() => setStateParameter(prev => prev ? undefined : !prev)}
                    disabled={!isGlobal}
                />
            </Grid>
            {(!isGlobal) && (
                <Grid container size={3.25}>
                    <Switch
                        checked={invertValue ? !moduleStateParameter : moduleStateParameter}
                        onClick={() => setModuleStateParameter(prev => prev ? undefined : !prev)}
                    />
                </Grid>
            )}
            <Grid size={0.5} />
        </Grid>
    )
}

ParameterWithSwitch.propTypes = {
    parameters: PropTypes.arrayOf(PropTypes.shape({})),
    setParameters: PropTypes.func,
    getGlobalParameter: PropTypes.func,
    moduleParameters: PropTypes.arrayOf(PropTypes.shape({})),
    setModuleParameters: PropTypes.func,
    getGlobalModuleParameter: PropTypes.func,
    isGlobal: PropTypes.bool,
    parameter: PropTypes.string,
    title: PropTypes.string,
    helpImage: PropTypes.node,
    invertValue: PropTypes.bool,
    description: PropTypes.node,
}

export default ParameterWithSwitch
